import React from 'react'

import { FALLBACK_FIELD_VALUE, type FormField } from './useViewFormModal'
import { type FieldComponentProps } from './fieldTypes'
import { renderFieldHelpText } from './HelpText'
import * as styles from './ViewFormModal.styles'

export const DefaultField = ({ field }: FieldComponentProps<FormField>) => {
  return (
    <styles.TextField>
      <styles.FieldLabel>{field.label}</styles.FieldLabel>
      {renderFieldHelpText(field.helpText)}
      <styles.FieldValue>{field.value ?? FALLBACK_FIELD_VALUE}</styles.FieldValue>
    </styles.TextField>
  )
}
